<div class="col full-height layout-column" *ngIf="vm">

  <!--Panel Skeleton, shown only until the routes have loaded for the first time-->
  <app-card-skeleton *ngIf="!vm.initialized" class="flex" [rows]="8"></app-card-skeleton>

  <div *ngIf="vm.initialized" class="flex layout-column dndList overflow-auto"
       cdkDropList
       [cdkDropListData]="vm.routes"
       id="{{panel.id}}"
       [cdkDropListEnterPredicate]="cdkEnterPredicate"
       [cdkDropListConnectedTo]="allPanelIds">

    <cdk-virtual-scroll-viewport class="flex layout-column"
                                 (scroll)="getNextBatch($event)"
                                 autosize
                                 [minBufferPx]="1000"
                                 [maxBufferPx]="2000">

      <app-routes-panel-list-item *cdkVirtualFor="let route of vm.routes; trackBy: trackById; templateCacheSize: 40"
                                  cdkDropList
                                  [id]="panel.id + '-' + route.id"
                                  [cdkDropListConnectedTo]="allPanelIds"
                                  [cdkDropListSortingDisabled]="true"
                                  [cdkDropListDisabled]="!!vm.loading || route.isBlockedByUser"
                                  (cdkDropListDropped)="onDrop(route, $event)"
                                  cdkDrag
                                  [cdkDragDisabled]="route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted"
                                  [cdkDragData]="route"
                                  [route]="route"
                                  [settings]="settings"
                                  [isSelected]="selectedKeys[route.id]"
                                  [excludeMode]="excludeMode"
                                  [isVisible]="visibleKeys[route.id]"
                                  [canSelect]="true"
                                  [canShow]="true"
                                  [canLock]="true"
                                  [canDrilldown]="true"
                                  (onToggle)="onToggleSelectedRoute(route, $event)"
                                  (onToggleVisible)="onToggleVisible.emit($event)"
                                  (onSelect)="onSelect.emit(route)"
                                  (onLockRouteChange)="onLockRouteChange.emit($event)"
                                  (onChangeRouteResource)="onSelectRouteResource.emit({route: route, event: $event.event})"
                                  (onDrillDown)="onDrillDown.emit($event)">

        <div cdkDragHandle>
          <bringoz-icon iconName="drag" class="secondary-100" [ngClass]="{disabled: route.status === routeStatusType.Completed || route.status === routeStatusType.Canceled || route.status === routeStatusType.Deleted}"></bringoz-icon>
        </div>

      </app-routes-panel-list-item>


    </cdk-virtual-scroll-viewport>

    <app-bringoz-linear-progress *ngIf="!!vm.loading"></app-bringoz-linear-progress>


    <div *ngIf="!vm.routes?.length && !vm.loading"
         class="flex-100 layout-row layout-align-center-center fade-element-in-only overflow-auto">
      <app-empty-state src="assets/images/empty_state/empty_state_routes.png"
                       text="No Routes Found">

      </app-empty-state>
    </div>

  </div>

</div>
